module.exports = __webpack_public_path__ + "static/media/error-message.9b56a00a.proto";